/* 侧边栏静态碎片组件 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import publicStyle from '../public/newsGroup.css';
import { classnames } from '../../../utils/classnames';
import { HtmlRegion } from '../../../components/htmlRegion';

class AsideStaticGroupComponent extends PureComponent {
    static propTypes = {
        content: PropTypes.string,
        componentOptions: PropTypes.object,
    };

    render() {
        const { content, componentOptions } = this.props;

        const element = <HtmlRegion content={content} />;

        return (
            <div className={publicStyle.news_group}>
                {/* 标题 */}
                {componentOptions.title ? (
                    <div className={`${publicStyle.news_group_title} clearfix`}>
                        <i className={classnames(publicStyle.block, 'block')} />
                        <span className={publicStyle.link_title}>{componentOptions.title}</span>
                    </div>
                ) : null}
                {element}
            </div>
        );
    }
}

export default errorBoundary(AsideStaticGroupComponent);
